import * as cx from 'classnames';
import * as React from 'react';
import * as Styles from './LoaderSpinner.scss';

interface ILoaderSpinnerProps {
  withOverlay?: boolean;
  width: number;
  height: number;
}

const LoaderSpinner = ({ withOverlay, width, height }: ILoaderSpinnerProps) => {
  const wrapper = cx({
    [Styles.wrapper]: !withOverlay,
    [Styles.wrapperWithOverlay]: withOverlay,
  });

  return (
    <span className={wrapper}>
      <span className={Styles.spinner} style={{ width, height, }} />
    </span>
  );
};

export default LoaderSpinner;
